var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index-page"},[_c('MainContainer'),_c('companyMsg'),_c('PriceContainer'),_c('ProductContainer',{attrs:{"broadHead":1,"typeParams":"1-1","columns":_vm.orderObj}}),_c('ProductContainer',{attrs:{"broadHead":2,"typeParams":"1-2","columns":_vm.cableList}}),_c('NewsContainer'),_c('CompanyShow'),_c('Partner'),_c('shop-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }